/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PrincipioActivoDto } from '../models/principio-activo-dto';
import { principiosActivosControllerActualizarPrincipiosActivos } from '../fn/principios-activos/principios-activos-controller-actualizar-principios-activos';
import { PrincipiosActivosControllerActualizarPrincipiosActivos$Params } from '../fn/principios-activos/principios-activos-controller-actualizar-principios-activos';
import { principiosActivosControllerListarPrincipiosActivos } from '../fn/principios-activos/principios-activos-controller-listar-principios-activos';
import { PrincipiosActivosControllerListarPrincipiosActivos$Params } from '../fn/principios-activos/principios-activos-controller-listar-principios-activos';

@Injectable({ providedIn: 'root' })
export class PrincipiosActivosService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `principiosActivosControllerActualizarPrincipiosActivos()` */
  static readonly PrincipiosActivosControllerActualizarPrincipiosActivosPath = '/api/principios-activos/actualizar-principios-activos';

  /**
   * Actualizar principios activos.
   *
   * Actualizar principios activos con parámetros configurables
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `principiosActivosControllerActualizarPrincipiosActivos()` instead.
   *
   * This method doesn't expect any request body.
   */
  principiosActivosControllerActualizarPrincipiosActivos$Response(params: PrincipiosActivosControllerActualizarPrincipiosActivos$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return principiosActivosControllerActualizarPrincipiosActivos(this.http, this.rootUrl, params, context);
  }

  /**
   * Actualizar principios activos.
   *
   * Actualizar principios activos con parámetros configurables
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `principiosActivosControllerActualizarPrincipiosActivos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  principiosActivosControllerActualizarPrincipiosActivos(params: PrincipiosActivosControllerActualizarPrincipiosActivos$Params, context?: HttpContext): Observable<void> {
    return this.principiosActivosControllerActualizarPrincipiosActivos$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `principiosActivosControllerListarPrincipiosActivos()` */
  static readonly PrincipiosActivosControllerListarPrincipiosActivosPath = '/api/principios-activos/listar-principios-activos';

  /**
   * Listar principios activos.
   *
   * Obtiene una lista de principios activos con búsqueda opcional
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `principiosActivosControllerListarPrincipiosActivos()` instead.
   *
   * This method doesn't expect any request body.
   */
  principiosActivosControllerListarPrincipiosActivos$Response(params?: PrincipiosActivosControllerListarPrincipiosActivos$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PrincipioActivoDto>>> {
    return principiosActivosControllerListarPrincipiosActivos(this.http, this.rootUrl, params, context);
  }

  /**
   * Listar principios activos.
   *
   * Obtiene una lista de principios activos con búsqueda opcional
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `principiosActivosControllerListarPrincipiosActivos$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  principiosActivosControllerListarPrincipiosActivos(params?: PrincipiosActivosControllerListarPrincipiosActivos$Params, context?: HttpContext): Observable<Array<PrincipioActivoDto>> {
    return this.principiosActivosControllerListarPrincipiosActivos$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PrincipioActivoDto>>): Array<PrincipioActivoDto> => r.body)
    );
  }

}
